export default {"src":"/_next/static/media/logo.6afb35c5.svg","height":40,"width":174,"blurWidth":0,"blurHeight":0};